import { render, staticRenderFns } from "./Blocks.vue?vue&type=template&id=fb6347aa&scoped=true&"
import script from "./Blocks.vue?vue&type=script&lang=js&"
export * from "./Blocks.vue?vue&type=script&lang=js&"
import style0 from "./Blocks.vue?vue&type=style&index=0&id=fb6347aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb6347aa",
  null
  
)

export default component.exports